import { FC, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { MotionValue, motion, useTransform } from 'framer-motion'

import { Overlay } from 'styles/misc'
import TVImageSrc from './assets/tv.png'
import KnobImageSrc from './assets/knob.png'

const Svg = styled.svg`
  display: block;
  ${Overlay}

  .button-background {
    fill: transparent;

    &:hover {
      background-color: rgba(255, 255, 255, 0.2);
    }
  }

  .button-symbol {
    fill: white;
  }
`

type Props = {
  progress: MotionValue<number>
  onScroll: (delta: number) => void
  onMinus: () => void
  onPlus: () => void
  isSticky?: boolean
}

export const TVImage: FC<Props> = ({ progress, onScroll, onMinus, onPlus }) => {
  const ref = useRef<SVGImageElement>(null)
  const rotateZ = useTransform(progress, v => `${v / 2}deg`)

  const handelWheel = (evt: WheelEvent) => {
    evt.preventDefault()
    evt.stopPropagation()
    onScroll(evt.deltaY / 10)
  }

  useEffect(() => {
    const r = ref.current
    r?.addEventListener('wheel', handelWheel, { passive: false })
    return () => r?.removeEventListener('wheel', handelWheel)
  }, [])

  return (
    <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1165 907">
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#f3e4cd" />
          <stop offset="1" stopColor="#dfc695" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#fff9ef" />
          <stop offset="1" stopColor="#dfc695" />
        </linearGradient>
        <clipPath id="clip-Web_1920_1">
          <rect width="1165" height="907" />
        </clipPath>
      </defs>
      <image id="tv" width="1165" height="907" href={TVImageSrc} />
      <circle
        cx="55.5"
        cy="55.5"
        r="55.5"
        transform="translate(941 619)"
        fill="url(#linear-gradient)"
      />
      <circle
        cx="53.5"
        cy="53.5"
        r="53.5"
        transform="translate(943 621)"
        fill="url(#linear-gradient-2)"
      />
      <g transform="translate(945 730)">
        <motion.g
          style={{ rotateZ, cursor: 'ew-resize' }}
          onPan={(_evt, info) => onScroll(info.delta.x)}
        >
          <image
            width="103"
            height="106"
            transform="translate(0 -106)"
            href={KnobImageSrc}
            ref={ref}
          />
        </motion.g>
      </g>

      <g
        data-name="button-minus"
        transform="translate(67 89)"
        style={{ cursor: 'pointer' }}
        onClick={onMinus}
      >
        <rect
          id="Rectangle_3"
          data-name="Rectangle 3"
          width="27"
          height="27"
          rx="7"
          transform="translate(897 661)"
          className="button-background"
        />
        <path
          id="Path_2"
          data-name="Path 2"
          d="M0-6.36v1.6H10v-1.6Z"
          transform="translate(906 680.36)"
          className="button-symbol"
        />
      </g>
      <g
        data-name="button-plus"
        transform="translate(-71 89)"
        style={{ cursor: 'pointer' }}
        onClick={onPlus}
      >
        <rect
          id="Rectangle_4"
          data-name="Rectangle 4"
          width="27"
          height="27"
          rx="7"
          transform="translate(1073 661)"
          className="button-background"
        />
        <path
          id="Path_1"
          data-name="Path 1"
          d="M6.68-5.74v-4.38H5.32v4.38H.96v1.36H5.32V0H6.68V-4.38h4.36V-5.74Z"
          transform="translate(1080.04 679.12)"
          className="button-symbol"
        />
      </g>
    </Svg>
  )
}
